import { GridItem, Text, Button, Flex } from '@tradener/lumen';

import { CreditCounterpartyProps } from '@graphql/query/operationLimits/credit/counterpartList';

import formatNegotiationDeadlineLabel from '~/utils/formatNegotiationDeadlineLabel';

import { COUNTERPARTY_RATING_BG_BY_LABEL, normalizeCounterpartyRating } from '../../utils/rating';

export interface CounterpartyListItemProps {
  item: CreditCounterpartyProps;
  onOpenDetail: (accountId: string, counterpartyName: string) => void;
}

const formatCurrency = (value: unknown) => {
  const normalized = Number(value);

  return Number.isFinite(normalized) ? normalized.formatCurrency('pt-BR') : '-';
};

function CounterpartyListItem({ item, onOpenDetail }: CounterpartyListItemProps) {
  const ratingLabel = normalizeCounterpartyRating(item.rating);

  return (
    <>
      <GridItem borderBottom="1px solid" borderColor="gray.100" py="3" px="3" display="flex" alignItems="center">
        <Flex direction="column" rowGap="1" justify="center" minW="0" width="full">
          <Button
            variant="link"
            color="gray.900"
            onClick={() => onOpenDetail(item.accountId, item.counterpartName)}
            fontWeight="medium"
            width="full"
            justifyContent="flex-start"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {item.counterpartName || '-'}
          </Button>
          <Text textStyle="caption1-regular" color="gray.500">
            {item.taxId ? item.taxId.formatTaxId() : '-'}
          </Text>
        </Flex>
      </GridItem>
      <GridItem borderBottom="1px solid" borderColor="gray.100" py="3" px="3" display="flex" alignItems="center">
        <Flex
          borderRadius="sm"
          alignItems="center"
          justifyContent="center"
          minW="2.35rem"
          height="1.7rem"
          px="2"
          bg={COUNTERPARTY_RATING_BG_BY_LABEL[ratingLabel]}
        >
          <Text textStyle="caption1-medium" color="white" lineHeight="1">
            {ratingLabel}
          </Text>
        </Flex>
      </GridItem>
      <GridItem borderBottom="1px solid" borderColor="gray.100" py="3" px="3" display="flex" alignItems="center">
        <Text textStyle="body2-regular">{formatNegotiationDeadlineLabel(item.negotiationDeadlineLabel) || '-'}</Text>
      </GridItem>
      <GridItem
        borderBottom="1px solid"
        borderColor="gray.100"
        py="3"
        px="3"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Text textStyle="body2-regular">{formatCurrency(item.exposureMtmFiltered)}</Text>
      </GridItem>
      <GridItem
        borderBottom="1px solid"
        borderColor="gray.100"
        py="3"
        px="3"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Text textStyle="body2-regular">{formatCurrency(item.exposureMtmGlobal)}</Text>
      </GridItem>
      <GridItem
        borderBottom="1px solid"
        borderColor="gray.100"
        py="3"
        px="3"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Text textStyle="body2-regular">{formatCurrency(item.limitAverage)}</Text>
      </GridItem>
      <GridItem
        borderBottom="1px solid"
        borderColor="gray.100"
        py="3"
        px="3"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Text textStyle="body2-regular">{formatCurrency(item.financialBalance)}</Text>
      </GridItem>
    </>
  );
}

export default CounterpartyListItem;
